import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import { Link } from "react-router-dom";
import campaigns from "../data/campaigns";

/*
 * LAMNA Credits — every donor who opts in gets their name here, permanently.
 * Names appear ONLY with explicit consent. Starts empty until the first
 * consented donation arrives.
 */

const Credits = () => {
  useDocTitle("ZelT | LAMNA Credits");

  const active = campaigns.find((c) => c.active);

  return (
    <div>
      <NavBar />
      <div className="mt-8 w-full bg-white py-12 lg:py-20">
        <div className="mx-4 max-w-3xl mx-auto text-center">
          <span className="text-5xl">🦈</span>
          <h1 className="text-4xl font-extrabold text-blue-900 mt-3 mb-3">
            LAMNA Credits
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-aos="fade-up">
            These are the people who gave LAMNA her brain. Every donor who
            opts in is listed here — permanently — as a thank-you from
            ZelTechnology and every family LAMNA helps.
          </p>

          {/* credits list — empty until first consented donation */}
          <div className="my-10" data-aos="zoom-in">
            <div className="border-2 border-dashed border-teal-300 rounded-2xl p-10 bg-teal-50">
              <p className="text-gray-500 italic">
                The first name here could be yours.
              </p>
              <p className="text-gray-400 text-sm mt-2">
                Credits appear after each donor gives consent — no name is
                ever published automatically.
              </p>
            </div>
          </div>

          {/* campaign reminder */}
          <div
            className="rounded-2xl p-6 text-left text-white shadow-xl"
            style={{ background: "linear-gradient(90deg, #1e3a8a, #36395a)" }}
            data-aos="fade-up"
          >
            <p className="font-bold text-lg mb-1">
              {active.icon} {active.name}
            </p>
            <p className="text-gray-300 text-sm mb-4">{active.perks}</p>
            <Link
              to="/transparency"
              className="inline-block px-5 py-2.5 rounded-xl bg-teal-400 text-blue-900 font-bold hover:bg-teal-300 transition"
            >
              View the Fund →
            </Link>
          </div>

          <p className="text-gray-400 text-xs mt-8">
            Donors may remain anonymous — credits appear only by explicit
            opt-in. ZelTechnology never publishes donor names or amounts
            without written permission.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Credits;
